'use client';

import wholesaleprogram1 from '@/assets/images/convention/wholesaleprogram/wholesaleprogram1.jpg';
import wholesaleprogram2 from '@/assets/images/convention/wholesaleprogram/wholesaleprogram2.jpg';
import FormError from '@/components/FormError';
import { trans } from '@/i18n';
import { Button, Checkbox, Form, Input } from 'antd';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { Fragment, useState } from 'react';
import { useWholesaleProgramPage } from './useWholesaleProgramPage';
import classes from './wholesaleProgramPage.module.css';

export const WholesaleProgramPage = () => {
  const talonProps = useWholesaleProgramPage();
  const router = useRouter();
  const { errors, wholesaleProgramSubmit, isSubmitting, response } = talonProps;
  const validateMessages = {
    required: 'This is required!',
    types: {
      email: '${label} is not a valid email!',
    },
  };
  const maybeSuccessInfo =
    response && response.code === '200' ? (
      router.push('/wholesale-success')
    ) : response && response.code === '500' ? (
      <span className={classes.msgerror}>{response.content}</span>
    ) : null;

  const onFinish = values => {
    wholesaleProgramSubmit(values);
  };

  const [isother, setValue] = useState({
    interested: false,
    howknow: false,
  });

  const lnterestedonChange = e => {
    const state = isother;

    if (e.target.value == 'other') {
      if (e.target.checked) {
        state.interested = true;
      } else {
        state.interested = false;
      }
    }

    const data = Object.assign({}, isother, {
      isother: state,
    });

    setValue(data);
  };

  const HowknowonChange = e => {
    const state = isother;

    if (e.target.value == 'other') {
      if (e.target.checked) {
        state.howknow = true;
      } else {
        state.howknow = false;
      }
    }

    const data = Object.assign({}, isother, {
      isother: state,
    });

    setValue(data);
  };

  return (
    <Fragment>
      <div className={classes.wholesaleprogram}>
        <h1 className={classes.title}>{trans('Wholesale Program')}</h1>
        <div className={classes.shipping}>
          <div className={classes.shippingcon}>
            <h1 className={classes.subtitle}>{trans('AW.Bridal Dropshipping Program')}</h1>
            <p>{trans("We handle the packing and shipping for you, so there's no inventory pressure on your end.")}</p>
            <br />
            <p>{trans('Please fill out the form below for more details and to get your questions answered.')}</p>
          </div>
          <div className={classes.shippingimg}>
            <Image
              src={wholesaleprogram1}
              alt=''
            />
          </div>
        </div>
        <div className={classes.wholesale}>
          <div className={classes.wholesalecon}>
            <h1 className={classes.subtitle}>{trans('AW.Bridal Wholesale Program')}</h1>
            <p>
              {trans('Our wholesale program is designed for partners with higher purchase volumes.')}
              &nbsp;{trans('We offer very competitive prices to help you grow your business.')}
            </p>
            <br />
            <p>{trans('Please fill out the form below and reach out to us with any questions.')}</p>
          </div>
          <div className={classes.wholesaleimg}>
            <Image
              src={wholesaleprogram2}
              alt=''
            />
          </div>
        </div>
        <div className={classes.application}>
          <h1 className={classes.formtitle}>{trans('AW.Bridal Wholesale Application')}</h1>
          <ul className={classes.formexplain}>
            <li>{trans('Fill out the wholesale request form below')}</li>
            <li>{trans('We will follow-up with you within a few days by email.')}</li>
          </ul>
          <Form
            layout='vertical'
            name='nest-messages'
            onFinish={onFinish}
            validateMessages={validateMessages}
            className={classes.form}
          >
            <Form.Item
              name={'firstname'}
              label={<span className='text-[15px]'>{trans('First Name')}</span>}
              rules={[
                {
                  required: true,
                  message: trans('This is required!'),
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={'lastname'}
              label={<span className='text-[15px]'>{trans('Last Name')}</span>}
              rules={[
                {
                  required: true,
                  message: trans('This is required!'),
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={'website'}
              label={<span className='text-[15px]'>{trans('Website')}</span>}
              rules={[
                {
                  required: true,
                  message: trans('This is required!'),
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={'storelocation'}
              label={<span className='text-[15px]'>{trans('Your Location')}</span>}
              rules={[
                {
                  required: true,
                  message: trans('This is required!'),
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={'noyib'}
              label={<span className='text-[15px]'>{trans('Number of Years in Business')}</span>}
              rules={[
                {
                  required: true,
                  message: trans('This is required!'),
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={'phone'}
              label={<span className='text-[15px]'>{trans('Phone Number')}</span>}
              rules={[
                {
                  message: trans('This is required!'),
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={'email'}
              label={<span className='text-[15px]'>{trans('Email')}</span>}
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: trans('email is required!'),
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label={<span className='text-[15px]'>{trans('Your Business Type:')}</span>}
              name='businesstype'
              rules={[
                {
                  required: true,
                  message: trans('This is required!'),
                },
              ]}
            >
              <Checkbox.Group>
                <Checkbox
                  value='bm'
                  style={{
                    fontSize: 15,
                  }}
                >
                  {trans('Bricks and Mortar')}
                </Checkbox>
                <Checkbox
                  value='or'
                  style={{
                    fontSize: 15,
                  }}
                >
                  {trans('Online Retailer')}
                </Checkbox>
                <Checkbox
                  value='rd'
                  style={{
                    fontSize: 15,
                  }}
                >
                  {trans('Rep Or Distributor')}
                </Checkbox>
              </Checkbox.Group>
            </Form.Item>
            <div className={classes.specialcheckbox}>
              <Form.Item
                label={<span className='text-[15px]'>{trans('Interested In:')}</span>}
                name='interested'
                rules={[
                  {
                    message: trans('This is required!'),
                    required: true,
                  },
                ]}
                onChange={lnterestedonChange}
              >
                <Checkbox.Group>
                  <Checkbox
                    value='wd'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Wedding Dresses')}
                  </Checkbox>
                  <Checkbox
                    value='bd'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Bridesmaid Dresses')}
                  </Checkbox>
                  <Checkbox
                    value='mbd'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Mother of Bride Dresses')}
                  </Checkbox>
                  <Checkbox
                    value='robes'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Robes')}
                  </Checkbox>
                  <Checkbox
                    value='ass'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Accessories')}
                  </Checkbox>
                  <Checkbox
                    value='other'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Other')}
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
              {isother.interested ? (
                <Form.Item
                  name={'itremark'}
                  id='itremark'
                  rules={[
                    {
                      message: trans('This is required!'),
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              ) : null}
            </div>
            <div className={classes.specialcheckbox}>
              <Form.Item
                label={<span className='text-[15px]'>{trans('How Do You Know AW.Bridal?')}</span>}
                name='howknow'
                rules={[
                  {
                    message: trans('This is required!'),
                    required: true,
                  },
                ]}
                onChange={HowknowonChange}
              >
                <Checkbox.Group>
                  <Checkbox
                    value='instagram'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Instagram')}
                  </Checkbox>
                  <Checkbox
                    value='facebook'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Facebook')}
                  </Checkbox>
                  <Checkbox
                    value='tiktok'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Tiktok')}
                  </Checkbox>
                  <Checkbox
                    value='pinterest'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Pinterest')}
                  </Checkbox>
                  <Checkbox
                    value='google'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Google')}
                  </Checkbox>
                  <Checkbox
                    value='other'
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {trans('Other')}
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
              {isother.howknow ? (
                <Form.Item
                  name={'hkremark'}
                  id='hkremark'
                  rules={[
                    {
                      message: trans('This is required!'),
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              ) : null}
            </div>
            <Form.Item
              name={'story'}
              label={<span className='text-[15px]'>{trans('Tell Us Your Story')}</span>}
            >
              <Input.TextArea rows={4} />
            </Form.Item>
            <Form.Item className={classes.subbtn}>
              <Button
                type='primary'
                disabled={isSubmitting}
                className={classes.submitbtn}
                htmlType='submit'
                style={{
                  borderRadius: 3,
                  fontFamily: 'jost',
                  textTransform: 'uppercase',
                }}
              >
                {isSubmitting ? trans('Sending...') : trans('Send')}
              </Button>
            </Form.Item>
            {maybeSuccessInfo}
            <FormError
              allowErrorMessages
              errors={Array.from(errors.values())}
            />
          </Form>
        </div>
      </div>
    </Fragment>
  );
};

export default WholesaleProgramPage;
